import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { tomos, tomoIncludes } from '../data/content';
export function PackOverview() {
  return <section id="contenido" aria-labelledby="contenido-titulo" className="w-full bg-navy py-14 text-white sm:py-20" data-id="element-178" data-mp="3m8o4b52yqf42">
      <div className="mx-auto max-w-6xl px-5" data-id="element-179" data-mp="3haw47ns5zmos">
        <div className="text-center" data-id="element-180" data-mp="2tjz3761wq9sb">
          <span className="inline-flex items-center gap-2 rounded-full bg-gold px-4 py-1.5 font-display text-xs font-extrabold uppercase tracking-widest text-navy-deep" data-id="element-181" data-mp="2tl1sxanhu66n">
            🏆 MegaPack™ listo
          </span>
          <h2 id="contenido-titulo" className="mx-auto mt-5 max-w-3xl font-display text-3xl font-extrabold leading-tight text-balance sm:text-4xl lg:text-5xl" data-id="element-182" data-mp="32lgjopj88dhj">
            Caligrafía y Lectoescritura — 6 Tomos + 6 Bonos
          </h2>
          <p className="mt-4 text-base text-celeste-light sm:text-lg" data-id="element-183" data-mp="dtmb7ds2rv27">
            Tomo 1 → Tomo 6 · <strong className="text-gold" data-id="element-184" data-mp="26legvil7ynw9">480+ páginas</strong> · Todo resuelto.
          </p>

          <ul className="mt-6 flex flex-wrap items-center justify-center gap-2" data-id="element-185" data-mp="2bjpr3ufff0f0">
            {tomos.map(tomo => <li key={tomo.id} className="rounded-lg bg-white/10 px-3 py-1.5 font-display text-sm font-bold text-white ring-1 ring-white/15" data-id="element-186" data-mp="2flbbs1y7cizr">
                {tomo.id}
              </li>)}
            <li className="rounded-lg bg-gold px-3 py-1.5 font-display text-sm font-bold text-navy-deep" data-id="element-187" data-mp="1nsam1tw9m502">
              + 6 Bonos
            </li>
          </ul>
        </div>

        <h3 className="mt-14 text-center font-display text-xl font-extrabold uppercase tracking-widest text-celeste" data-id="element-188" data-mp="1wtiie6f80vri">
          6 Tomos completos
        </h3>

        <ul className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-189" data-mp="146xqn4uu2hnf">
          {tomos.map((tomo, index) => <motion.li key={tomo.id} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.06,
          ease: 'easeOut'
        }} className="flex h-full flex-col rounded-2xl bg-white p-5 text-navy shadow-card" data-id="element-190" data-mp="194pkw5iyafus" data-mpi={index}>
              <span className="text-2xl" aria-hidden="true" data-id="element-191" data-mp="2h6v5l0q3g33p">
                {tomo.emoji}
              </span>
              <h4 className="mt-2 font-display text-lg font-extrabold leading-tight" data-id="element-192" data-mp="1tik8m8niqnkp">
                {tomo.title}
              </h4>
              <p className="font-display text-sm font-bold text-celeste-dark" data-id="element-193" data-mp="1okirht9nkybv">
                {tomo.subtitle}
              </p>
              <p className="mt-3 text-sm leading-relaxed text-navy/75" data-id="element-194" data-mp="1xjdwx34vi4e4">
                {tomo.description}
              </p>
            </motion.li>)}
        </ul>

        <div className="mt-12 rounded-2xl border border-white/15 bg-white/5 p-6 sm:p-8" data-id="element-195" data-mp="3dzgsperjyhe0">
          <h3 className="font-display text-xl font-extrabold text-gold" data-id="element-196" data-mp="38y1b5wol2t0d">
            Cada tomo incluye:
          </h3>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-197" data-mp="3hho22oybi001">
            {tomoIncludes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-198" data-mp="37h3wja3rm9c0">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-celeste" aria-hidden="true" data-id="element-199" data-mp="37iouzat7acf5" />
                <span className="text-sm leading-relaxed text-white/90 sm:text-base" data-id="element-200" data-mp="40naa12mx77k">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}